export const certificates = [
  {
    id: "1",
    img: "/images/cer/1.png",
    alt: "1",
  },
  {
    id: "2",
    img: "/images/cer/2.png",
    alt: "2",
  },
  {
    id: "3",
    img: "/images/cer/3.jpg",
    alt: "3",
  },
  {
    id: "4",
    img: "/images/cer/4.jpg",
    alt: "4",
  },

  {
    id: "5",
    img: "/images/cer/5.png",
    alt: "5",
  },
  { id: "6", img: "/images/cer/6.png", alt: "6" },
  {
    id: "7",
    img: "/images/cer/7.png",
    alt: "7",
  },
  {
    id: "8",
    img: "/images/cer/8.png",
    alt: "8",
  },
  {
    id: "9",
    img: "/images/cer/9.png",
    alt: "9",
  },
  {
    id: "10",
    img: "/images/cer/10.png",
    alt: "10",
  },
];
